import React, { useState, useEffect, useRef } from 'react'
import WilliamImge from "../../assets/william-background.png";
import backgroundYellow from "../../assets/images/backgroundYellow.png";
import WilliamImge2 from "../../assets/william-background2.png";
import Discover from "../../assets/images/Discover.jpg";
import PowerLineBanner from "../../assets/Powerline-main.jpg";
import SmallIConPower from "../../assets/small-icon-powerline.png";
import LegecyBackground from "../../assets/legacy-background-image.jpg";
import ProsperityImage from "../../assets/prosperityImage.png";
import purposeImage from "../../assets/purposeImage.png";
import LongevityImage from "../../assets/LongevityImage.png";
import rebon from "../../assets/rebon.png"
import kayak from "../../assets/kayak.png"
import wave from "../../assets/wave.png"
import NewHeader from "../Neweheader";
import logo from "../../assets/logo.png"
import headerLogo from '../../assets/headerlogo.png';
import './newhome2.css';
import PowerlineForm from '../powerline/PowerlineForm';
import Certainty from "../../assets/Certainty.png";
import Playicon from "../../assets/playicon.png";
import Arrowicon from "../../assets/arrowicon.png";
import VideoPlayer from '../../Common/Components/VideoPlayer';
import DialogComponent from '../../Inputs/DailogComponent';
import Player from '@vimeo/player';
import { useNavigate } from 'react-router-dom';
import { storeAssigned } from '../../services/Methods/normalMethods';
import footerlogo from '../../assets/footer-image.png';
import VisitorList from '../../Common/Components/VisitorComponent';


const videos = {
    legacy: "https://player.vimeo.com/video/1064121596?autoplay=1&autopause=0&controls=true",
    longevity: "https://player.vimeo.com/video/1082278141?autoplay=1&autopause=0&controls=true",
    abundant: "https://player.vimeo.com/video/1064352451?autoplay=1&autopause=0&controls=true",
    passionate: "https://player.vimeo.com/video/1057650843?autoplay=1&autopause=0&controls=true",
    life_on_mission: "https://player.vimeo.com/video/1064121583?autoplay=1&autopause=0&controls=true",
    beginings: "https://player.vimeo.com/video/1087593619?autoplay=1&autopause=0&controls=true",
};

const NewHome2 = () => {

    const [openVideoPopup, setOpenVideoPopup] = useState(true);
    const navigate = useNavigate();

    const homevideo = 'https://player.vimeo.com/video/1064121583?autoplay=1&loop=1&autopause=0&muted=1&controls=true&background=1';

    const secondhomevideo = 'https://player.vimeo.com/video/1064121589?autoplay=1&loop=1&autopause=0&muted=1&controls=true&background=1';

    const [activeVideo, setActiveVideo] = useState(null);
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [currentVideo, setCurrentVideo] = useState(null);

    const openPopup = (videoKey) => {
        setCurrentVideo(videos[videoKey]);
        setIsPopupOpen(true);
    };

    const closePopup = () => {
        setIsPopupOpen(false);
        setCurrentVideo(null);
    };

    const iframeRef = useRef(null);
    const playerRef = useRef(null);

    useEffect(() => {
        if (isPopupOpen && iframeRef.current) {
            playerRef.current = new Player(iframeRef.current);
            playerRef.current.on('ended', () => setIsPopupOpen(false));
        }

        return () => {
            if (playerRef.current) playerRef.current.off('ended');
        };
    }, [isPopupOpen]);


    return (
        <>
            {/* <NewHeader /> */}
            <section className='py-[50px] bg-no-repeat bg-center bg-cover' style={{ backgroundImage: `url(${Discover})` }}>
                <div className="container 2xl:max-w-[1760px] xl:max-w-[1440px] lg:max-w-[1170px] md:max-w-[970px] max-w-[740px] mx-auto px-[15px] relative">
                    <div className='flex xl:min-h-[80vh] min-h-[70vh] flex-wrap'>
                        <div className="left lg:w-[60%] w-full flex flex-col">
                            <div className="dis">
                                <h2 className='mb-[20px] text-white text-center font-osw xl:text-[50px] xl:leading-[60px] lg:text-[40px] lg:leading-[50px] md:text-[35px] md:leading-[40px] text-[30px] leading-[40px]'>DISCOVER YOUR LEGACY</h2>
                                <div className='max-w-[430px] mx-auto'>
                                    <p className='mb-[15px] italic font-[18px] text-white text-center'>The opportunity of a lifetime, must be grasped in the lifetime of the opportunity.</p>
                                    <p className='italic text-white text-center'>- Leonard Ravenhill</p>
                                </div>
                            </div>
                            <div className="btn-div flex xl:gap-[30px] gap-[10px] lg:mt-[auto] mt-[30px] md:flex-row flex-col items-center">
                                <button class="bg-[#0071BA] tex-white 2xl:text-[24px] xl:text-[20px] leading-[1.3] md:text-[18px] text-[16px]  font-normal p-[8px_15px] max-w-[470px] w-full text-[#fff] transition delay-150 duration-300 ease-in-out hover:bg-[#2b72a1] shadow-[3px_3px_8px_#00000029] md:min-h-[78px] min-h-[60px]" onClick={() => window.location.href = `/${storeAssigned()}/retail_signup`}>Become a RETAIL CUSTOMER</button>

                                <button class="bg-[#0071BA] tex-white 2xl:text-[24px] xl:text-[20px] leading-[1.8] md:text-[18px] text-[16px] font-normal p-[8px_15px] max-w-[470px] w-full text-[#fff] transition delay-150 duration-300 ease-in-out hover:bg-[#2b72a1] shadow-[3px_3px_8px_#00000029] md:min-h-[78px] min-h-[60px]" onClick={() => window.location.href = `/${storeAssigned()}/business_owner`}>Become a WHOLESALE AFFILIATE Lock in Your LegacyLine Position</button>
                            </div>
                        </div>
                        <div className="right flex flex-col xl:pt-[140px] lg:pt-[80px] pt-[20px] lg:pl-[15px] pl-0 lg:w-[40%] w-full">
                            <div className="form">
                                <h2 className='text-white text-start lg:text-[35px]  md:text-[30px] text-[25px] mb-[15px]'>TIME IS OF THE ESSENCE</h2>
                                <VisitorList />
                            </div>
                            <div className="btn-div mt-auto pt-[30px] ">
                                <button class="bg-[#0071BA] 2xl:text-[24px] xl:text-[20px] leading-[1.3] md:text-[18px] text-[16px] md:min-h-[78px] min-h-[60px] font-normal p-[8px_15px] max-w-[370px] w-full text-[#fff] uppercase transition delay-150 duration-300 ease-in-out hover:bg-[#2b72a1] shadow-[3px_3px_8px_#00000029] mx-auto  block" onClick={() => window.open(`/api/Files/documents/LegcyLine_Overview_text.pdf`, '_blank')} >LEGACY OVERVIEW</button>
                            </div>
                        </div>
                    </div>
                </div>
            </section >



            <section className='bg-[#fff] pt-[50px]'>

                <div className='container max-w-[1380px] mx-auto px-[15px] relative z-[2] min-h-[678px]'>
                    <div className='border border-black absolute top-0 left-[15px] w-[calc(100%-30px)] bg-[#f2f4fa] h-full'>
                        <img className='w-full z-[1] h-[100%] object-cover' src={backgroundYellow} alt="" />
                    </div>
                    <div className="wraper-div flex md:justify-between justify-center h-full flex-wrap min-h-[660px]">
                        <div className="left md:pt-[109px] pt-[50px] relative lg:left-[150px] md:left-[50px] left-[0px] px-[15px] md:w-auto w-full">
                            <h2 className='font-osw text-[#5E5E5E] xl:text-[90px] xl:leading-[90px] lg:text-[80px] lg:leading-[80px] md:text-[70px] md:leading-[70px] text-[60px] leading-[60px]'><img className='xl:max-w-[311px] lg:max-w-[250px] md:max-w-[230px] max-w-[200px] block h-full w-full object-contain' src={headerLogo} alt="logo" /></h2>

                        </div>
                        <div className="right max-w-[620px] mt-auto lg:pb-[80px] pb-[30px] relative xl:right-[120px] right-[0px] md:w-auto ml-auto !w-full px-[15px]">
                            <h3 className='text-[#000000] xl:text-[49px] lg:text-[40px] text-[30px] font-normal text-center font-osw xl:leading-[60px] leading-[1.4]'>
                               BEGINNINGS
                            </h3>

                            <h5 className='mt-[15px] text-[#000000] xl:text-[30px] lg:text-[28px] text-[20px] font-normal text-center font-osw xl:leading-[40px] leading-[1.4]'>
                                The Provizion Story
                            </h5>

                            <button
                                onClick={() => openPopup("beginings")}
                                className="gap-[10px] mt-[10px] bg-[#c8a666] mx-auto flex xl:text-[24px] lg:text-[20px] text-[18px] text-[#000] leading-normal max-w-[351px] w-full text-center justify-center items-center xl:min-h-[76px] min-h-[56px] shadow-[3px_3px_8px_#00000029;] transition duration-300 ease-in-out hover:bg-[#af8d3d]  hover:text-[#000]">WATCH VIDEO <span><img className='w-[23px] h-[23px] object-contain' src={Playicon} alt="" /></span></button>
                        </div>
                    </div>
                </div>
            </section>



            {/* <section className="experience_sec xl:pt-[70px] pt-[50px]">
                <div className='container xl:max-w-[1380px] mx-auto px-[15px]'>
                    <div className="relative iner-div bg-no-repeat bg-center xl:bg-cover !bg-contain xl:h-[790px] lg:h-[690px] md:h-[500px] h-[400px]" style={{ backgroundImage: `url(${WilliamImge})`, backgroundSize: "998px", backgroundPosition: "left" }}>

                        <div className="left-div md:max-w-[500px] max-w-full w-full relative xl:left-[150px] ">
                            <h2 className="md:text-left text-center font-osw xl:text-[90px] lg:text-[70px] md:text-[50px] text-[40px] font-normal text-[#5E5E5E] leading-[1]">EXPERIENCE</h2>
                            <h4 className="md:text-left text-center xl:text-[49.5px] lg:text-[38px] md:text-[28px] text-[22px] font-normal text-[#5E5E5E] leading-[1]">LIFE ON MISSION</h4>
                        </div>

                        <div className="right-div md:max-w-[510px] max-w-full w-full text-center absolute top-[210px] xl:-right-[160px] italic">
                            <p className="text-[#5E5E5E] xl:text-[24px] text-[20px] leading-[30px] font-semibold">“The great use of life is to spend it for something that will outlast it.”</p>
                            <p className="text-[#5E5E5E] xl:text-[24px] text-[20px] leading-[30px] mt-[30px] font-semibold">— William James</p>
                        </div>

                    </div>
                </div>
            </section> */}




            {/* <section className="xl:h-[795px] lg:h-[690px] md:h-[500px] h-[400px] bg-no-repeat bg-center bg-cover flex items-end relative " style={{ backgroundImage: `url(${SecondBackgroundImge})` }} >

                <div className="video_btn flex flex-col max-w-[max-content] mx-auto justify-center text-center">
                    <button onClick={() => openPopup("life_on_mission")} className="md:text-[16px] text-[14px] mb-[30px] border-[3px] border-[#C5A65F] text-[#C5A65F] uppercase p-2 max-w-[max-content] mx-auto leading-normal font-semibold transition duration-300 ease-in-out hover:bg-[#000]">Life On Mission</button>
                </div>
            </section> */}
            {/* 
            <section className="hero_banner relative">
                <div className=" relative pb-[38%] ">
                    <VideoPlayer className="top-0 left-0 " url={secondhomevideo} style={{ width: '100%', height: '100%', right: 0, }} />
                </div>
                <div className="inner-div flex flex-col justify-end mt-[20px]">
                    <div className="video_btn absolute xl:bottom-[40px] bottom-[10px] left-1/2 transform -translate-x-1/2 -translate-y-1/2">
                        <button className="md:text-[16px] text-[14px] border-[3px] border-[#C5A65F] text-[#C5A65F] uppercase p-2 max-w-[max-content] mx-auto leading-normal font-semibold transition duration-300 ease-in-out hover:bg-[#000]">
                            Life On Mission
                        </button>
                    </div>
                </div>
            </section> */}


            <section className="pt-[0px]">
                <div className='container max-w-[1380px] mx-auto px-[15px]'>
                    {/* {activeVideo === "legacy" ? (
                        <div className="w-full pb-[56%] relative comon_video">
                            <VideoPlayer url={videos.legacy} className="w-full h-full rounded-lg" />
                        </div>
                    ) : (
                        <div className="relative first-div">
                            <img src={LegecyBackground} alt="Legacy Background" className="w-full h-auto" />

                            <div className="md:absolute xl:top-[70px] top-[20px] xl:right-[100px] right-[15px] p-6 bg-white shadow-lg rounded-lg md:max-w-[500px]">
                                <h2 className="font-osw text-[#000] xl:text-[49px] lg:text-[40px] text-[30px] font-normal text-center xl:leading-[60px] leading-[1.4]">
                                    HOW WE BUILD LEGACY
                                </h2>
                                <img className="flex mx-auto mt-2" src={SmallIConPower} alt="Power Icon" />


                                <button
                                    onClick={() => openPopup("legacy")}
                                    className="gap-[10px] mt-[10px] bg-[#c8a666] mx-auto flex xl:text-[24px] lg:text-[20px] text-[18px] text-[#000] leading-normal max-w-[351px] w-full text-center justify-center items-center xl:min-h-[76px] min-h-[56px] shadow-[3px_3px_8px_#00000029] transition duration-300 ease-in-out hover:bg-[#af8d3d] hover:text-[#000]"
                                >
                                    WATCH VIDEO
                                    <span>
                                        <img className='w-[23px] h-[23px] object-contain' src={Playicon} alt="Play Icon" />
                                    </span>
                                </button>

                            </div>
                        </div>
                    )} */}


                    {activeVideo === "longevity" ? (
                        <div className="mt-[15px] w-full pb-[56%] relative comon_video">
                            <VideoPlayer url={videos.longevity} className="w-full h-full rounded-lg" />
                        </div>
                    ) : (
                        <div className="second-div relative xl:mt-[74px] mt-[50px]">
                            <img src={LongevityImage} alt="" />
                            <div className="discri_sec md:max-w-[376px] text-center md:absolute top-[50%] md:-translate-y-[50%]  xl:left-[100px] left-[15px] md:bg-transparent bg-white md:shadow-none shadow-lg md:p-[0] p-[24px]">
                                <h2 className="text-[#000000] xl:text-[49px] lg:text-[40px] text-[30px] font-normal text-center font-osw xl:leading-[60px] leading-[1.4]">VIBRANT LONGEVITY PRODUCTS</h2>
                                <h5 className="#000 text-[25px] xl:mb-[56px] mb-[30px] font-osw">For Pure Cellular Energy</h5>
                                <button
                                    onClick={() => openPopup("longevity")}
                                    className="gap-[10px] mt-[10px] bg-[#c8a666] mx-auto flex xl:text-[24px] lg:text-[20px] text-[18px] text-[#000] leading-normal max-w-[351px] w-full text-center justify-center items-center xl:min-h-[76px] min-h-[56px] shadow-[3px_3px_8px_#00000029;] transition duration-300 ease-in-out hover:bg-[#af8d3d]  hover:text-[#000]">WATCH VIDEO <span><img className='w-[23px] h-[23px] object-contain' src={Playicon} alt="" /></span></button>

                                <button onClick={() => navigate(`/${storeAssigned()}/longevity`)} className="xl:mt-[30px] mt-[12px] gap-[10px] bg-[#c8a666] mx-auto flex xl:text-[24px] lg:text-[20px] text-[18px] text-[#000] leading-normal max-w-[351px] w-full text-center justify-center items-center xl:min-h-[76px] min-h-[56px] shadow-[3px_3px_8px_#00000029;] transition duration-300 ease-in-out hover:bg-[#af8d3d]  hover:text-[#000] uppercase">learn more <span><img className='w-[23px] h-[23px] object-contain' src={Arrowicon} alt="" /></span></button>


                            </div>
                        </div>
                    )}


                    {activeVideo === "abundant" ? (
                        <div className="mt-[15px] w-full pb-[56%] relative comon_video">
                            <VideoPlayer url={videos.abundant} className="w-full h-full rounded-lg" />
                        </div>
                    ) : (
                        <div className="third-div relative xl:mt-[74px] mt-[50px]">
                            <img src={ProsperityImage} alt="" />
                            <div className="discri_sec md:max-w-[435px] text-center md:absolute top-[50%] md:-translate-y-[50%] xl:right-[100px] right-[15px] md:bg-transparent bg-white md:shadow-none shadow-lg md:p-[0] p-[24px]">
                                <h2 className="text-[#000000] xl:text-[49px] lg:text-[40px] text-[30px] font-normal text-center font-osw xl:leading-[60px] leading-[1.4]">ABUNDANT PROSPERITY SYSTEM</h2>
                                <h5 className="#000 text-[25px] xl:mb-[56px] mb-[30px] font-osw">For Continuous Income</h5>
                                <button
                                    onClick={() => openPopup("abundant")}
                                    className="gap-[10px] mt-[10px] bg-[#c8a666] mx-auto flex xl:text-[24px] lg:text-[20px] text-[18px] text-[#000] leading-normal max-w-[351px] w-full text-center justify-center items-center xl:min-h-[76px] min-h-[56px] shadow-[3px_3px_8px_#00000029;] transition duration-300 ease-in-out hover:bg-[#af8d3d]  hover:text-[#000]">WATCH VIDEO <span><img className='w-[23px] h-[23px] object-contain' src={Playicon} alt="" /></span></button>

                                <button onClick={() => navigate(`/${storeAssigned()}/prosperity`)} class="xl:mt-[30px] mt-[12px] gap-[10px] bg-[#c8a666] mx-auto flex xl:text-[24px] lg:text-[20px] text-[18px] text-[#000] leading-normal max-w-[351px] w-full text-center justify-center items-center xl:min-h-[76px] min-h-[56px] shadow-[3px_3px_8px_#00000029;] transition duration-300 ease-in-out hover:bg-[#af8d3d]  hover:text-[#000] uppercase">learn more <span><img className='w-[23px] h-[23px] object-contain' src={Arrowicon} alt="" /></span></button>
                            </div>
                        </div>
                    )}


                    {activeVideo === "passionate" ? (
                        <div className="mt-[15px] w-full pb-[56%] relative comon_video">
                            <VideoPlayer url={videos.passionate} className="w-full h-full rounded-lg" />
                        </div>
                    ) : (
                        <div className="forth-div relative xl:mt-[74px] mt-[50px]">
                            <img src={purposeImage} alt="" />
                            <div className="discri_sec md:max-w-[406px] text-center md:absolute top-[50%] md:-translate-y-[50%] xl:left-[100px] left-[15px] md:bg-transparent bg-white md:shadow-none shadow-lg md:p-[0] p-[24px]">
                                <h2 className="text-[#000000] xl:text-[49px] lg:text-[40px] text-[30px]  font-normal text-center font-osw xl:leading-[60px] leading-[1.4]">PASSIONATE PURPOSE TRAINING</h2>
                                <h5 className="#000 xl:text-[25px] text-[22px] mt-[15px] mb-[40px] font-osw">It’s What You Where Born For</h5>
                                <button
                                    onClick={() => openPopup("passionate")}
                                    className="gap-[10px] mt-[10px] bg-[#c8a666] mx-auto flex xl:text-[24px] lg:text-[20px] text-[18px] text-[#000] leading-normal max-w-[351px] w-full text-center justify-center items-center xl:min-h-[76px] min-h-[56px] shadow-[3px_3px_8px_#00000029;] transition duration-300 ease-in-out hover:bg-[#af8d3d]  hover:text-[#000]">WATCH VIDEO <span><img className='w-[23px] h-[23px] object-contain' src={Playicon} alt="" /></span></button>

                                <button onClick={() => navigate(`/${storeAssigned()}/purpose`)} class="xl:mt-[30px] mt-[12px] gap-[10px] bg-[#c8a666] mx-auto flex xl:text-[24px] lg:text-[20px] text-[18px] text-[#000] leading-normal max-w-[351px] w-full text-center justify-center items-center xl:min-h-[76px] min-h-[56px] shadow-[3px_3px_8px_#00000029;] transition duration-300 ease-in-out hover:bg-[#af8d3d]  hover:text-[#000] uppercase">learn more <span><img className='w-[23px] h-[23px] object-contain' src={Arrowicon} alt="" /></span></button>
                            </div>
                        </div>
                    )}
                </div>
                {/* <img className="ribon-img relative md:-mt-[110px]" src={rebon} alt="" /> */}
            </section>
            <section className='xl:pt-[100px] lg:pt-[60px] pt-[0px] relative z-[2]'>
                <div className='container mx-auto chosse-legecy-section flex pt-[40px] 2xl:z-[1] z-[3] relative lg:flex-nowrap flex-wrap'>
                    <div className='choose-legacy-heading text-center xl:w-[60%] lg:w-[50%] w-full'>
                        <h2 className='lg:text-right text-center lg:pr-[100px] pr-0 lg:mb-0 mb-[30px] font-osw xl:text-[50px] xl:leading-[90px] lg:text-[40px] lg:leading-[50px] md:text-[35px] md:leading-[40px] text-[30px] leading-[40px]'>Choose your legacy</h2>
                    </div>
                    <div className='visitors-section xl:pt-[90px] lg:pt-[0px] xl:pl-[50px] pl-[15px] xl:w-[40%] lg:w-[50%] w-full'>
                        <VisitorList />
                    </div>
                </div>
                <div className="btn-wrapper flex justify-center xl:gap-[100px] xl:mt-[73px] lg:gap-[50px] lg:mt-[50px] gap-[20px] mt-[30px]  md:flex-nowrap flex-wrap">
                    <button className="bg-[#0071BA] tex-white xl:text-[24px] xl:leading-[55px] md:text-[20px] md:leading-[40px] text-[18px] leading-[30px] font-normal p-[8px_15px] max-w-[470px] w-full text-[#fff] uppercase transition delay-150 duration-300 ease-in-out hover:bg-black shadow-[3px_3px_8px_#00000029]" onClick={() => window.open(`/api/Files/documents/LegcyLine_Overview_text.pdf`, '_blank')}>LEGACY OVERVIEW</button>
                </div>
                <div className='img 2xl:z-[2] z-[1] relative'>
                    <img className="mx-auto relative 2xl:-top-[815px] xl:-top-[720px] -top-[0px]" src={rebon} alt="king" />
                </div>
            </section>

            <section className='lg:p-[130px_0_137px] p-[100px_0_50px]  bg-no-repeat bg-center bg-cover relative xl:-mt-[500px] lg:-mt-[100px] -mt-[80px] z-[99]' style={{ backgroundImage: `url(${WilliamImge2})`, backgroundSize: "1530px", backgroundPosition: "center top" }}>
                <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 xl:gap-8 gap-3 px-[15px]">

                    <div className="border p-6 bg-white flex flex-col items-center">
                        {/* <div className="btn-wrapper flex justify-center xl:gap-[100px] xl:mt-[73px] lg:gap-[50px] lg:mt-[50px] gap-[20px] mt-[30px]  md:flex-nowrap flex-wrap">
                                                    <button className="bg-[#0071BA] tex-white xl:text-[24px] xl:leading-[55px] md:text-[20px] md:leading-[40px] text-[18px] leading-[30px] font-normal p-[8px_15px] max-w-[470px] w-full text-[#fff] uppercase transition delay-150 duration-300 ease-in-out hover:bg-black shadow-[3px_3px_8px_#00000029]">LEGACY OVERVIEW</button>
                                     </div>
                                     <div className="btn-wrapper flex justify-center xl:gap-[100px] lg:gap-[50px] gap-[20px] md:flex-nowrap flex-wrap">
                                                    <button className="bg-[#0071BA] tex-white xl:text-[24px] xl:leading-[55px] md:text-[20px] md:leading-[40px] text-[18px] leading-[30px] font-normal p-[8px_15px] max-w-[470px] w-full text-[#fff] uppercase transition delay-150 duration-300 ease-in-out hover:bg-black shadow-[3px_3px_8px_#00000029]">LEGACY OVERVIEW</button>
                                     </div> */}
                        <div className='md:max-w-[450px] max-w-full w-full mx-auto'>
                            <button className="bg-[#0071BA] text-white w-full text-center py-3 font-semibold text-lg mb-4" onClick={() => window.location.href = `/${storeAssigned()}/retail_signup`}>
                                BECOME A RETAIL CUSTOMER
                            </button>
                            <img src="/Images/retailcustomer.jpg" alt="Retail Customer" className="mb-4" />
                            <ul className="list-disc pl-5 text-black space-y-2 text-sm font-semibold">
                                <li className="font-semibold">Purchase Provizion products whenever you wish, from your store within this website</li>
                                <li>Access to Purpose International’s samples, discounted materials, and courses.</li>
                                <li>Access to samples and discounts on Dr. Greenman’s desk reference book on Glutathione.</li>
                            </ul>
                        </div>
                    </div>

                    <div className="border p-6 bg-white flex flex-col items-center">
                        <div className='md:max-w-[450px] max-w-full w-full mx-auto'>
                            <button className="bg-[#0071BA] text-white w-full text-center py-3 font-semibold text-lg mb-4" onClick={() => window.location.href = `/${storeAssigned()}/business_owner`}>
                                BECOME A WHOLESALE AFFILIATE
                            </button>
                            <img src="/Images/wholesale.jpg" alt="Wholesale Affiliate" className="mb-4" />
                            <ul className="list-disc pl-5 text-black space-y-2 text-sm font-semibold">
                                <li>New Affiliates who were sponsored by Affiliates above you will be placed into your LegacyLine Team.</li>
                                <li>Sponsor New Affiliates and Retail Customers of your own.</li>
                                <li>Purchase Provizion products when you wish, from the back-office area of your Affiliate website.</li>
                                <li>Sell products to anyone at Retail pricing and keep the profit.</li>
                                <li>Receive Commissions, Bonuses, and Rewards.</li>
                                <li>Access to all Affiliate personal and business training materials.</li>
                            </ul>
                        </div>
                    </div>
                </div>


                {/* <div className='overlay absolute top-[90px] left-0 w-full h-[calc(100%-150px)] bg-[#F6F7FB] opacity-[0.57] z-[1]'></div>
                                        <div className='container xl:max-w-[1380px] mx-auto px-[15px] relative z-[2]'>
                                            <div className="title">
                                                <h2 className="font-osw text-[#000000] xl:text-[70px] lg:text-[60px] md:text-[50px] text-[30px] font-normal text-center font-osw xl:leading-[104px] lg:leading-[70x] mg:leading-[60x] leading-[40x]">YOUR LEGACY IS WAITING FOR YOU</h2>
                                                <h3 className='xl:text-[50px] xl:leading-[60px] lg:text-[40px] lg:leading-[30px] text-[28px] leading-[38px] text-[#000000] text-center md:mt-[27px] mt-[18px] md:mb-[25px] mb-[18px]     '>And We’ll Help Create It </h3>
                                                <h3 className='xl:mb-[37px] mb-[25px] xl:text-[50px] xl:leading-[60px] lg:text-[40px] lg:leading-[30px] text-[28px] leading-[38px] text-[#000000] text-center'>INSTANT ACCESS</h3>
                                            </div>
                        
                                            <div className="form">
                                                <PowerlineForm />
                                            </div>
                                            <p className=
                                            
                                            'xl:text-[24px] lg:text-[20px] text-[18px] mx-auto pt-[46px] text-center leading-[30px] text-[#000] max-w-[640px]'>We will immediately email your digital copy of Dr. Greenman’s highly acclaimed book, <b className='italic'>Absolute Certainty.</b></p>
                                        </div> */}


                <div className="bg-[#f3f4f6f2] container max-w-6xl mx-auto mt-[40px]">
                    <div className="xl:p-[40px] md:p-[20px] p-[25px_15px]">
                        <h2 className="font-osw xl:text-[40px] lg:text-[35px] text-[30px] leading-[1.2] text-center xl:mb-12 mb-4">
                            AFFILIATE AMENITIES
                        </h2>

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-start">

                            <div>
                                <ul className="text-black text-lg">
                                    {[
                                        { title: "LegacyLine", desc: "position and invitation link" },
                                        { title: "Quality of Life", desc: "chart for tracking health/longevity" },
                                        { title: "Personal Affiliate", desc: "website" },
                                    ].map((item, index) => (
                                        <li key={index} className="flex items-start gap-3">
                                            <i className="fa fa-check text-yellow-500 text-2xl mt-1" aria-hidden="true"></i>
                                            <span>
                                                <strong>{item.title}</strong> {item.desc}
                                            </span>
                                        </li>
                                    ))}

                                    <li className="flex items-start gap-3">
                                        <i className="fa fa-check text-yellow-500 text-2xl mt-1" aria-hidden="true"></i>
                                        <div>
                                            <strong>TeamProvizion.com</strong>
                                            <ul className="list-disc pl-6 mt-2 text-base space-y-1">
                                                <li>Personal Purpose Materials</li>
                                                <li>LegacyLine Training</li>
                                                <li><strong>Media Library</strong> of approved marketing tools</li>
                                                <li>Graphics</li>
                                                <li>Product fliers</li>
                                                <li>Videos</li>
                                                <li>Pop up banners</li>
                                                <li>and More!</li>
                                            </ul>
                                        </div>
                                    </li>

                                    {[
                                        { title: "Access", desc: "Your Kingdom Purpose Blueprint - Module 1: our faith-based video series" },
                                        { title: "Access chapters 1-4 of", desc: "Master Keys Of Life: our standard life course materials" },
                                        { title: "Access 70 pages of", desc: "Glutathione: King of The Master: Molecules of Health, Dr. Bill Greenman's book" },
                                        { title: "Access", desc: "The Legacy Podcast – weekly interviews, product and business building insights" },
                                    ].map((item, index) => (
                                        <li key={`access-${index}`} className="flex items-start gap-3">
                                            <i className="fa fa-check text-yellow-500 text-2xl mt-1" aria-hidden="true"></i>
                                            <span>
                                                {item.title} <strong>{item.desc}</strong>
                                            </span>
                                        </li>
                                    ))}

                                </ul>
                            </div>

                            <div className="flex justify-center relative">
                                <div className="flex flex-col items-center space-y-6">
                                    <img
                                        src="/Images/books.png"
                                        alt="Blueprint"
                                        className="w-100"
                                    />

                                </div>
                            </div>

                        </div>
                    </div>
                </div>

            </section>
            {/* <footer className="bg-[#000000] py-[45px] relative z-[2]">
                <div className='container xl:max-w-[1380px] mx-auto px-[15px]'>
                    <img className="flex mx-auto" src={footerlogo} alt="" />
                    <div className="copy-div flex justify-center md:mt-[48px] mt-[30px]" >
                        <ul className="flex md:gap-[20px] gap-[10px] md:flex-nowrap flex-wrap md:justify-start justify-center">
                            <li className='md:w-auto w-full md:text-start text-center'> <a href="#" className=" text-[#fff] xl:text-[20px] md:text-[16px] text-[14px] font-light leading-[1]" >© Copyright 2025 Provizion Global LLC All Rights Reserved</a></li>
                            <li><a className="text-[#fff] xl:text-[20px] md:text-[16px] text-[14px] font-light leading-[1]" href="#"><span className="mr-[20px] md:inline-block  hidden">|</span> Privacy Policy</a></li>
                            <li><a className="text-[#fff] xl:text-[20px] md:text-[16px] text-[14px] font-light leading-[1]" href="#"><span className="md:mr-[20px] mr-[10px]">|</span>Terms of Use</a></li>
                        </ul>
                    </div>
                </div>
            </footer> */}
            {
                isPopupOpen && (
                    <div className="video-popup-overlay">
                        <div className="video-popup-content">
                            <button className="close-button" onClick={() => setIsPopupOpen(false)}>
                                &times;
                            </button>
                            <iframe
                                src={currentVideo}
                                ref={iframeRef}
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                                title="Embedded Video"
                                className="video-iframe"
                            ></iframe>
                        </div>
                    </div>
                )
            }

        </>
    )
}

export default NewHome2;